var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7917 6.20833L20.7355 8.26458L24.498 12.0417H9.66675V14.9583H24.498L20.7355 18.7208L22.7917 20.7917L30.0834 13.5L22.7917 6.20833ZM3.83341 3.29167H15.5001V0.375H3.83341C2.22925 0.375 0.916748 1.6875 0.916748 3.29167V23.7083C0.916748 25.3125 2.22925 26.625 3.83341 26.625H15.5001V23.7083H3.83341V3.29167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.861312fa152656ef9281fbfb03fddd85.svg";
export { ForwardRef as ReactComponent };